(function () {
  const prompt = document.getElementById('MarketLocationPrompt');

  if (!prompt || !window.fetch || !window.Shopify || !window.Shopify.routes) return;

  // shop.domain identifies the store even in a localhost or theme preview URL.
  // localization.country identifies the shopper's country, not the current store.
  const storeDomain = (prompt.dataset.storeDomain || '').toLowerCase().replace(/^www\./, '');
  const storeCountry = { 'rewahard.com': 'NZ', 'rewahard.com.au': 'AU' }[storeDomain];
  if (!storeCountry) return;
  const switchButton = prompt.querySelector('.market-location-prompt__switch');
  const stayButton = prompt.querySelector('.market-location-prompt__stay');
  const closeButton = prompt.querySelector('.market-location-prompt__close');
  const title = prompt.querySelector('.market-location-prompt__title');
  const lead = prompt.querySelector('.market-location-prompt__lead');
  const benefit = prompt.querySelector('.market-location-prompt__benefit');
  const stayCopy = prompt.querySelector('.market-location-prompt__stay-copy');
  const root = window.Shopify.routes.root || '/';
  let recommendation;
  let previouslyFocused;
  let waitingObserver;
  let waitingTimer;
  let escapeHeld = false;
  let consumeEscapeKeyup = false;

  const content = {
    AU: {
      title: 'SHOPPING FROM\nAUSTRALIA?',
      lead: 'We have a dedicated Australian store for you.',
      benefit: 'Shop in AUD, enjoy Australia-only offers and faster local delivery.',
      switchLabel: 'TAKE ME TO REWAHARD AUSTRALIA',
      storeUrl: 'https://rewahard.com.au/',
      stayCopy:
        'Prefer to stay here? You can continue shopping on our NZ store, however international shipping charges will apply for delivery to Australia.',
      stayLabel: 'CONTINUE SHOPPING NZ',
    },
    NZ: {
      title: 'SHOPPING FROM\nNEW ZEALAND?',
      lead: 'We have a dedicated New Zealand store for you.',
      benefit: 'Shop in NZD, enjoy New Zealand-only offers and faster local delivery.',
      switchLabel: 'TAKE ME TO REWAHARD NEW ZEALAND',
      storeUrl: 'https://rewahard.com/',
      stayCopy:
        'Prefer to stay here? You can continue shopping on our Australian store, however international shipping charges will apply for delivery to New Zealand.',
      stayLabel: 'CONTINUE SHOPPING AU',
    },
  };

  function activeStoreMatches(country) {
    return storeCountry === country;
  }

  function storageKey(type) {
    return `rewahard-market-location-${type}-${recommendation.country}-${storeCountry}`;
  }

  function readStorage(storage, key) {
    try {
      return window[storage].getItem(key);
    } catch {
      return null;
    }
  }

  function writeStorage(storage, key, value) {
    try {
      window[storage].setItem(key, value);
    } catch {
      // Remembering the choice is optional; storage failure must not prevent closing.
    }
  }

  function isSuppressed() {
    if (window.RewaStorePreference?.hasChosenStore(storeCountry)) return true;
    const persistentUntil = Number(readStorage('localStorage', storageKey('stay')) || 0);
    return persistentUntil > Date.now() || readStorage('sessionStorage', storageKey('close')) === 'true';
  }

  function closePrompt(sessionOnly) {
    if (sessionOnly) writeStorage('sessionStorage', storageKey('close'), 'true');
    prompt.setAttribute('aria-hidden', 'true');
    prompt.hidden = true;
    document.documentElement.classList.remove('market-location-prompt-open');
    if (previouslyFocused && typeof previouslyFocused.focus === 'function') previouslyFocused.focus();
  }

  function renderPrompt() {
    const copy = content[recommendation.country];
    title.textContent = copy.title;
    lead.textContent = copy.lead;
    benefit.textContent = copy.benefit;
    switchButton.textContent = copy.switchLabel;
    switchButton.setAttribute('href', copy.storeUrl);
    stayCopy.textContent = copy.stayCopy;
    stayButton.textContent = copy.stayLabel;
    previouslyFocused = document.activeElement;
    prompt.hidden = false;
    prompt.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('market-location-prompt-open');
    window.setTimeout(() => {
      if (!prompt.hidden) closeButton.focus();
    }, 0);
  }

  function hasForegroundOverlay() {
    if (
      document.querySelector(
        'cart-drawer.active, cart-notification.active, #search-modal.active, .header-mobile__menu.active, rewa-store-selector details[open], modal-dialog[open], quick-add-modal[open], dialog[open]'
      )
    )
      return true;
    // Include app dialogs, while ignoring hidden/inactive dialog markup in the theme.
    return Array.from(document.querySelectorAll('[role="dialog"][aria-modal="true"]')).some((dialog) => {
      if (prompt.contains(dialog) || dialog.closest('details:not([open])') || !dialog.getClientRects().length)
        return false;
      const style = window.getComputedStyle(dialog);
      return style.visibility !== 'hidden' && style.display !== 'none';
    });
  }

  function stopWaiting() {
    if (waitingObserver) waitingObserver.disconnect();
    waitingObserver = null;
    window.clearTimeout(waitingTimer);
    waitingTimer = undefined;
  }

  function schedulePrompt() {
    if (waitingTimer !== undefined) return;
    // Let the original overlay finish its close/focus handlers before showing ours.
    waitingTimer = window.setTimeout(() => {
      waitingTimer = undefined;
      tryPrompt();
    }, 300);
  }

  function tryPrompt() {
    if (!recommendation || !prompt.hidden || isSuppressed()) {
      stopWaiting();
      return;
    }
    if (escapeHeld || hasForegroundOverlay()) {
      if (!waitingObserver) {
        waitingObserver = new MutationObserver(schedulePrompt);
        waitingObserver.observe(document.body, {
          childList: true,
          subtree: true,
          attributes: true,
          attributeFilter: ['class', 'open', 'hidden', 'aria-hidden', 'aria-modal', 'style'],
        });
      }
      return;
    }
    stopWaiting();
    renderPrompt();
  }

  function onKeydown(event) {
    if (event.key === 'Escape') escapeHeld = true;
    if (prompt.hidden || !recommendation) return;

    if (event.key === 'Escape') {
      consumeEscapeKeyup = true;
      event.preventDefault();
      event.stopImmediatePropagation();
      closePrompt(true);
    }
    if (event.key !== 'Tab') return;

    const controls = Array.from(prompt.querySelectorAll('button:not([disabled]), a[href]'));
    const first = controls[0];
    const last = controls[controls.length - 1];
    if (!controls.includes(document.activeElement)) {
      event.preventDefault();
      (event.shiftKey ? last : first).focus();
    } else if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  closeButton.addEventListener('click', () => closePrompt(true));
  stayButton.addEventListener('click', () => {
    writeStorage('localStorage', storageKey('stay'), String(Date.now() + 30 * 24 * 60 * 60 * 1000));
    closePrompt(false);
  });
  document.addEventListener('keydown', onKeydown, true);
  document.addEventListener(
    'keyup',
    (event) => {
      if (event.key !== 'Escape') return;
      escapeHeld = false;
      if (consumeEscapeKeyup) {
        consumeEscapeKeyup = false;
        event.preventDefault();
        event.stopImmediatePropagation();
      }
      if (waitingObserver) schedulePrompt();
    },
    true
  );
  window.addEventListener('blur', () => {
    escapeHeld = false;
    consumeEscapeKeyup = false;
    if (waitingObserver) schedulePrompt();
  });
  // CSS completion may hide an overlay without producing a DOM mutation.
  ['transitionend', 'animationend'].forEach((type) => {
    document.addEventListener(
      type,
      () => {
        if (waitingObserver) schedulePrompt();
      },
      true
    );
  });

  // 明确的手动选站优先，不因目的站的 GeoIP 推荐被建议切回。
  if (window.RewaStorePreference?.hasChosenStore(storeCountry)) return;

  window
    .fetch(`${root}browsing_context_suggestions.json?country[enabled]=true`)
    .then((response) => (response.ok ? response.json() : null))
    .then((data) => {
      const country =
        data && data.detected_values && data.detected_values.country && data.detected_values.country.handle;
      if (!content[country] || activeStoreMatches(country)) return;
      recommendation = { country };
      tryPrompt();
    })
    .catch(() => {
      // The recommendation is optional; a failed GeoIP lookup must not affect storefront browsing.
    });
})();

function collectionFilter(e){
  
  // Add / Remove class
  $('ul.type-filter__list').toggleClass('show_all')

  // 2. button text update (Show more -> Show less )
  let hasShowAllClass = $("ul.type-filter__list").hasClass("show_all");

  if (hasShowAllClass == true){
    // height is auto.
    // Change button text to 'Show less'
    $('#collection_filter_load_more').text('Show less');
    $('html,body').animate({scrollTop: 0}, 500); // Scroll to Top

  } else {
    // false, height is fixed, only show 2 lines
    // Change button text to 'Show more'
    $('#collection_filter_load_more').text('Show more');
    
  }

}

(() => {
  if (!document.documentElement.hasAttribute('data-au-klaviyo-embed-only')) return;

  // CSS blocks rendering first; use Klaviyo's own close control to release modal state.
  const dialogSelector = '[role="dialog"][aria-label$=" Form"]';
  const footerSelector = '.klaviyo-form-S3yVbV';

  function dismissDialogs(scope) {
    if (!(scope instanceof Element)) return;

    const dialogs = new Set(scope.querySelectorAll(dialogSelector));
    const containingDialog = scope.closest(dialogSelector);
    if (containingDialog) dialogs.add(containingDialog);

    dialogs.forEach((dialog) => {
      if (dialog.closest(footerSelector)) return;

      const closeButton = dialog.querySelector('button.klaviyo-close-form');
      if (!closeButton || closeButton.hasAttribute('data-au-dismissed')) return;

      closeButton.setAttribute('data-au-dismissed', '');
      closeButton.click();
    });
  }

  const observer = new MutationObserver((records) => {
    records.forEach((record) => {
      record.addedNodes.forEach(dismissDialogs);
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });
  dismissDialogs(document.body);
})();

window.setRewaclubTabHiddenForMobileOverlay = function(hidden) {
  const hiddenClass = 'is-rewaclub-tab-hidden-by-overlay';

  document.querySelectorAll('.' + hiddenClass).forEach(function(element) {
    element.classList.remove(hiddenClass);
  });

  if (!hidden || !window.matchMedia('(max-width: 749px)').matches) {
    return;
  }

  const walker = document.createTreeWalker(
    document.body,
    NodeFilter.SHOW_TEXT,
    {
      acceptNode: function(node) {
        const text = (node.textContent || '').trim().toUpperCase();

        return text.includes('REWACLUB') ||
          text.includes('EARN POINT') ||
          text.includes('EARN POINTS')
          ? NodeFilter.FILTER_ACCEPT
          : NodeFilter.FILTER_REJECT;
      },
    }
  );

  while (walker.nextNode()) {
    let element = walker.currentNode.parentElement;

    while (element && element !== document.body) {
      const style = window.getComputedStyle(element);
      const rect = element.getBoundingClientRect();
      const isFloating =
        style.position === 'fixed' ||
        style.position === 'sticky' ||
        style.position === 'absolute';
      const isBottomLeftTab =
        rect.width > 0 &&
        rect.height > 0 &&
        rect.width <= 380 &&
        rect.height <= 220 &&
        rect.left < window.innerWidth * 0.55 &&
        rect.top > window.innerHeight * 0.35;

      if (isFloating && isBottomLeftTab) {
        element.classList.add(hiddenClass);
        break;
      }

      element = element.parentElement;
    }
  }
};

window.syncRewaclubTabForMobileOverlay = function() {
  window.setRewaclubTabHiddenForMobileOverlay(
    Boolean(document.querySelector('.header-mobile__menu.active, #search-modal.active'))
  );
};

document.addEventListener('DOMContentLoaded', function() {
  const header = document.querySelector('.header--culture-home');

  if (!header) {
    return;
  }

  const menuItems = Array.from(header.querySelectorAll('.header_list-item.have-submenu'))
    .filter(function(item) {
      return item.querySelector('.header-mega-menu');
    });

  if (!menuItems.length) {
    return;
  }

  let closeTimer;
  header.classList.add('is-culture-menu-ready');

  function clearCloseTimer() {
    window.clearTimeout(closeTimer);
  }

  function setActiveItem(activeItem) {
    clearCloseTimer();
    menuItems.forEach(function(item) {
      item.classList.toggle('is-culture-menu-active', item === activeItem);
    });
    document.body.classList.add('is-culture-menu-open');
  }

  function closeActiveItem(delay) {
    clearCloseTimer();
    closeTimer = window.setTimeout(function() {
      menuItems.forEach(function(item) {
        item.classList.remove('is-culture-menu-active');
      });
      document.body.classList.remove('is-culture-menu-open');
    }, delay);
  }

  menuItems.forEach(function(item) {
    item.addEventListener('mouseenter', function() {
      setActiveItem(item);
    });

    item.addEventListener('mouseleave', function() {
      closeActiveItem(120);
    });

    item.addEventListener('focusin', function() {
      setActiveItem(item);
    });

    item.addEventListener('focusout', function(event) {
      if (!item.contains(event.relatedTarget)) {
        closeActiveItem(0);
      }
    });
  });

  const plainMenuItems = header.querySelectorAll('.header_list-item:not(.have-submenu)');

  plainMenuItems.forEach(function(item) {
    item.addEventListener('mouseenter', function() {
      closeActiveItem(0);
    });
  });

  header.addEventListener('mouseleave', function() {
    closeActiveItem(120);
  });

  header.addEventListener('focusout', function(event) {
    if (!header.contains(event.relatedTarget)) {
      closeActiveItem(0);
    }
  });
});


$(document).ready(function() {
  // Only on the collection page
  if (window.location.href.includes('collections')){
    checkFilterHeight();
  }
});


function checkFilterHeight(){
  console.log('checkFilterHeight');

  let filterNode = $('.type-filter__list')
  let filterNodeHeight = filterNode.height(); // 84 content height
  let listHeight = 30;
  let gap = 24;
  let twoLineHeight = (listHeight * 2) + gap; // 84

  console.log('checkFilterHeight', filterNode, filterNodeHeight);

  if (filterNode.length > 0){
    // filter node exist.
    if (filterNodeHeight > twoLineHeight){
      // keep button
      // Add class to the list
      filterNode.addClass('has_height')
      
    } else{
      // hide button
      $('.filter_list_wrap').hide()
    }
  }
}

// Add a click event to elements with the class .pills-variant-labels
$('.pills-variant-labels').on('click', function() {
  // Get the text content without the span inside
  const labelText = $(this).contents().filter(function() {
    return this.nodeType === 3; // Filter out non-text nodes (such as the span)
  }).text().trim();
  
  // Your code to handle the text content goes here
  console.log('Label Text:', labelText);

  $('.swatchProductColor').each(function() {
    var urlHandle = $(this).data('handle');
    newUrlHandle = urlHandle + '?size=' + labelText;
    console.log('urlHandle', newUrlHandle);
    $(this).attr('data-handle', newUrlHandle);
    localStorage.setItem('selectedSize', labelText);
  });
});

$(document).ready(function() {
  // Function to get the value of a query parameter
  function getQueryParam(param) {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(param);
  }

  // Function to get the product identifier from the URL
  function getProductIdentifier() {
    const pathname = window.location.pathname;
    const parts = pathname.split('-');
    return parts[parts.length - 1];
  }

  // Function to store the selected size in local storage
  function storeSelectedSize(size) {
    localStorage.setItem('selectedSize', size);
  }

  // Function to retrieve the selected size from local storage
  function getSelectedSize() {
    return localStorage.getItem('selectedSize');
  }

  // Get the size query parameter value
  const sizeParam = getQueryParam('size');

  // Use the locally stored size if available
  const storedSize = getSelectedSize();

  if (storedSize) {
    // Loop over elements with the class .pills-variant-labels
    $('.pills-variant-labels').each(function() {
      // Get the text content without the span inside
      const labelText = $(this).contents().filter(function() {
        return this.nodeType === 3; // Filter out non-text nodes (such as the span)
      }).text().trim();

      // Check if the labelText matches the storedSize
      if (labelText === storedSize) {
        // Trigger a click on the matching element
        $(this).click();
        return false; // Exit the loop once a match is found
      }
    });
  } else if (sizeParam) {
    // Use the sizeParam if locally stored size is not available
    // Loop over elements with the class .pills-variant-labels
    $('.pills-variant-labels').each(function() {
      // Get the text content without the span inside
      const labelText = $(this).contents().filter(function() {
        return this.nodeType === 3; // Filter out non-text nodes (such as the span)
      }).text().trim();

      // Check if the labelText matches the sizeParam
      if (labelText === sizeParam) {
        // Trigger a click on the matching element
        $(this).click();
        return false; // Exit the loop once a match is found
      }
    });

    // Store the selected size in local storage
    storeSelectedSize(sizeParam);
  }

  // Check for URL changes
  $(window).on('popstate', function() {
    const currentProductIdentifier = getProductIdentifier();
    const previousSize = getSelectedSize();

    // Check if the product identifier is the same and a size was previously selected
    if (currentProductIdentifier === getProductIdentifier() && previousSize) {
      console.log('Previously selected size:', previousSize);
    }
  });
});


console.log('previousSize', localStorage.selectedSize);


document.addEventListener("DOMContentLoaded", function() {
    // Select all product cards with the specified class
    const productCards = document.querySelectorAll('.collection-product-card.quickview--hover');

    // Add event listeners for hover
    productCards.forEach(card => {
        card.addEventListener('mouseenter', function() {
            const video = card.querySelector('.media video');
            if (video) {
                video.play();
            }
        });

        card.addEventListener('mouseleave', function() {
            const video = card.querySelector('.media video');
            if (video) {
                video.pause();
                video.currentTime = 0; // Optional: reset the video to start
            }
        });
    });
});

document.addEventListener("DOMContentLoaded", function() {
          console.log('testjkj');

  setTimeout(() => {
                   // Select all video elements
    const videos = document.querySelectorAll('video');

    // Change preload attribute to auto for all video elements
    videos.forEach(video => {
        console.log('video', video)
        video.setAttribute('preload', 'auto');
        video.load(); // This will trigger the loading process
    });
                        }, 2000); // 2000 milliseconds = 2 seconds

    
  
    // Select all subitems
    const subitems = document.querySelectorAll('.product__media-sublist .product__media-subitem');

    // Add click event listener to each subitem
    subitems.forEach(subitem => {
        subitem.addEventListener('click', function() {
            // Loop over all media items
            const mediaItems = document.querySelectorAll('.product__media-list .product__media-item');

            mediaItems.forEach(mediaItem => {
                // Check if the media item has the class .swiper-slide-active
                if (mediaItem.classList.contains('swiper-slide-active')) {
                    // Find the .deferred-media__poster inside the active media item
                    const poster = mediaItem.querySelector('.deferred-media__poster');
                    
                    // Trigger a click on the .deferred-media__poster after a 2-second delay if it exists
                    if (poster) {
                        setTimeout(() => {
                            poster.click();
                        }, 500); // 2000 milliseconds = 2 seconds
                    }
                }
            });
        });
    });
});
